module.exports = __webpack_public_path__ + "img/d1.c6b46b86.png";